import CtaBand from '../components/CtaBand';
import FaqList from '../components/FaqList';
import Layout, { PageHero } from '../components/Layout';
import { FAQ_GROUPS } from '../constants/content';

export default function FaqsPage() {
  return (
    <Layout>
      <PageHero
        eyebrow="FAQs"
        title="Frequently asked questions"
        lead="Quick answers about Ancestry accounts, trees, DNA, updates — and how our independent helps works."
        crumbs={[{ label: 'FAQs' }]}
      />
      <section className="section">
        <div className="container container--narrow">
          <nav className="chips chips--center" aria-label="FAQ sections">
            {FAQ_GROUPS.map((g) => (
              <a key={g.id} href={`#${g.id}`} className="chip">
                {g.title}
              </a>
            ))}
          </nav>
          {FAQ_GROUPS.map((g) => (
            <div key={g.id} id={g.id} className="faq-group">
              <h2>{g.title}</h2>
              <FaqList items={g.items} />
            </div>
          ))}
        </div>
      </section>
      <CtaBand title="Didn’t find your question?" />
    </Layout>
  );
}
